import { fmtFecha } from "@/lib/format";
import { Badge } from "@/components/ui/badge";

function Campo({ label, value, sub, destacado, negativo }) {
  return (
    <div className="space-y-1">
      <p className="text-xs text-zinc-500">{label}</p>
      <p
        className={`text-sm font-semibold ${
          negativo ? "text-rose-700" : destacado ? "text-emerald-700" : "text-zinc-900"
        }`}
      >
        {value ?? "—"}
      </p>
      {sub && <p className="text-[11px] text-zinc-400">{sub}</p>}
    </div>
  );
}

const ESTADO_BADGE = {
  aprobada: "border-emerald-200 bg-emerald-50 text-emerald-800",
  pendiente: "border-amber-200 bg-amber-50 text-amber-800",
  pendiente_confirmacion: "border-indigo-200 bg-indigo-50 text-indigo-800",
};

export default function VacacionesResumen({ vacaciones }) {
  if (!vacaciones) return null;
  const v = vacaciones;
  const arrastre = Number(v.arrastre || 0);
  const anio = v.anio || new Date().getFullYear();

  return (
    <div className="space-y-4">
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <Campo label="Días anuales (cupo)" value={v.dias_anuales} />
        <Campo label="Modo" value={v.modo === "habiles" ? "Hábiles" : "Naturales"} sub={v.modo_label} />
        <Campo
          label={`Del año ${anio}`}
          value={v.del_anio ?? v.disponibles}
          sub={v.proporcional ? `Prorrateo por antigüedad · ${v.meses_trabajados} meses en el año` : "Cupo completo del año (alta antes del 1 de enero)"}
        />
        <Campo
          label="Arrastre / deuda"
          value={arrastre > 0 ? `+${arrastre}` : arrastre}
          sub={
            v.arrastre_activo === false
              ? "Arrastre desactivado en la empresa"
              : v.arrastre_motivo || (arrastre < 0 ? "Deuda del periodo anterior" : arrastre > 0 ? "Pendientes del año anterior" : "Sin arrastre")
          }
          negativo={arrastre < 0}
        />
        <Campo
          label="Total disponible"
          value={v.disponibles}
          sub={`${v.del_anio ?? "—"} del año ${arrastre ? `${arrastre >= 0 ? "+" : ""}${arrastre} arrastre` : ""}`.trim()}
        />
        <Campo
          label="Días restantes"
          value={v.restantes}
          sub={`${v.usados ?? 0} usados de ${v.disponibles} en ${anio}${
            v.anio_inicio_computo ? ` · cómputo desde ${v.anio_inicio_computo} (primer picado)` : ""
          }`}
          destacado={v.restantes >= 0}
          negativo={v.restantes < 0}
        />
        <Campo label="Días usados" value={v.usados} sub={
          v.usados_ajuste
            ? `${v.usados_ajuste} d. previos a la incorporación + resto en solicitudes (${anio})`
            : `Vacaciones aprobadas en ${anio}`
        } />
        <Campo
          label="Asignados pendientes"
          value={v.asignados_pendientes ?? 0}
          sub="En revisión o pendientes de confirmar"
        />
      </div>

      {v.periodos?.length > 0 ? (
        <div>
          <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-zinc-500">
            Periodos usados o asignados ({anio})
          </p>
          <ul className="max-h-56 space-y-2 overflow-y-auto">
            {v.periodos.map((p) => (
              <li
                key={p.id}
                className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-zinc-100 bg-zinc-50/80 px-3 py-2 text-sm"
              >
                <div className="min-w-0">
                  <p className="font-medium text-zinc-800">
                    {fmtFecha(p.fecha_inicio)} — {fmtFecha(p.fecha_fin)}
                  </p>
                  {p.motivo && <p className="truncate text-xs text-zinc-500">{p.motivo}</p>}
                </div>
                <div className="flex shrink-0 items-center gap-2">
                  <span className="text-xs font-medium text-zinc-600">{p.dias} d</span>
                  <Badge variant="outline" className={`text-[10px] ${ESTADO_BADGE[p.estado] || ""}`}>
                    {p.estado_label || p.estado}
                  </Badge>
                </div>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <p className="rounded-lg border border-dashed border-zinc-200 py-6 text-center text-sm text-zinc-400">
          Sin periodos de vacaciones registrados este año.
        </p>
      )}
    </div>
  );
}
